function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 339 501.9",
    style: {
      enableBackground: "new 0 0 339 501.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M312.4,109l-92.7-76.5c-5.3-4.6-11.6-6.8-18.4-6.8H71c-29.6,0-53.7,23.7-53.7,52.6v345.4 c0,28.8,24.1,52.6,53.7,52.6h196.6c30,0,54-23.7,54-52.6V128.5C321.7,121,318.3,113.9,312.4,109z M159.2,223.2h45.5v47.5 l-23.2,23.2h-22.3V223.2z M181.3,302.4c0,0.1,0,0.1,0,0.3v46.6c0,0.1,0,0.1,0,0.2c-0.2,1-1,1.6-1.8,1.6h-46.6 c-0.9,0-1.6-0.6-1.8-1.5v-47.2c0.1-1,1-1.5,1.8-1.5h46.6C180.4,300.8,181.2,301.5,181.3,302.4z M107.9,223.2h45.3v70.7h-22.1 l-23.2-23.2V223.2z M63.5,247.2c0-13.2,10.9-24,24-24h14.5v50l22.2,22.2v27.6H63.5V247.2z M102,429.6H87.4c-13.2,0-24-10.9-24-24 V329h60.9v27.7L102,378.9V429.6z M153.2,429.6H108v-48.4l23.1-23.2h22.1V429.6z M159.3,358h22.2l23.3,23.2v48.4h-45.5V358z  M242.1,405.6c0,13.2-10.6,24-24.1,24h-7.3v-50.8l-22.3-22.3c0-0.1,0-0.1,0-0.3v-27.3h53.7V405.6z M242.1,322.9h-53.9v-27.3 c0-0.1,0-0.1,0-0.3l22.3-22.3v-50h7.4c13.2,0,24.1,10.9,24.1,24V322.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSim);
export default __webpack_public_path__ + "static/media/sim.62c9d2f1d6fe346c8a10ad2630fada27.svg";
export { ForwardRef as ReactComponent };